// import ScrollReveal from './shared/scrollReveal';
import AccordionFaq from './shared/accordionFaq';
import CustomPlayer from './shared/customPlayer';
import CustomSelect from './shared/customSelect';
import FullSlide from './shared/fullSlide';
import FullSlideSimple from './shared/fullSlideSimple';
import HorizontalTab from './shared/horizontalTab';
import MobileMenu from './shared/mobileMenu';
import PinMappa from './shared/pinMappa';
import PlayVideo from './shared/playVideo';
import { ScrollParallax } from './shared/scroll-parallax';
import { ScrollRevealLock } from './shared/scroll-reveal-lock';
import { ScrollRevealStepper } from './shared/scroll-reveal-stepper';
import { ScrollRevealVideo } from './shared/scroll-reveal-video';
import ShowcaseColor from './shared/showcaseColor';
import ShowcaseSlide from './shared/showcaseSlide';
import VerticalTab from './shared/verticalTab';
import BackTop from './shared/backtop';
import SelectLang from './shared/selectLang';


export default class Main {

	constructor() {
		this.init();
	}

	init() {
		this.addListeners();
	}

	addListeners() {
		document.addEventListener("DOMContentLoaded", function() {
			// ScrollReveal.init();
			ScrollRevealLock.init();
			ScrollRevealVideo.init();
			ScrollRevealStepper.init();
			ScrollParallax.init();
			FullSlide.init();
			PlayVideo.init();
			ShowcaseSlide.init();
			HorizontalTab.init();
			VerticalTab.init();
			ShowcaseColor.init();
			FullSlideSimple.init();
			AccordionFaq.init();
			CustomSelect.init();
			MobileMenu.init();
			PinMappa.init();
			CustomPlayer.init();
			BackTop.init();
			SelectLang.init();
		});
	}
}

const main = new Main();
